import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=05c686bc&scoped=true"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=05c686bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c686bc",
  null
  
)

export default component.exports